<template>
	<button class="hotspot-scene__tab"
	        type="button"
	     @click.prevent="updateVisibleSceneIndex"
	     :style="style"
	     @mouseenter.prevent="mouseenter()"
	     @mouseleave.prevent="mouseleave()" v-html="tabName">
	</button>
</template>

<script lang="ts" setup>
import {computed, watch, ref} from 'vue';

const componentName = 'SceneTab';
const emit = defineEmits(['updateVisibleSceneIndex', 'updateChosenScene', 'scrollUpdate']);
import {Scene} from 'Interfaces/interfaces';
const hovering = ref<boolean>(false);
const props = defineProps({
	tabName: {
		type: String,
		default: ''
	},
	scene: {
		type: Object as () => Scene,
		default: () => ({})
	},
	index: {
		type: Number,
		default: 0
	},
	sceneAssociatedColor: {
		type: String,
		default: ''
	},
	activeIndex: {
		type: Number,
		default: 0
	}
});

const isDarkColor = (hexColor) => {
	// Remove the '#' if it's present
	hexColor = hexColor.replace('#', '');

	// Convert hex to RGB
	const r = parseInt(hexColor.substr(0, 2), 16);
	const g = parseInt(hexColor.substr(2, 2), 16);
	const b = parseInt(hexColor.substr(4, 2), 16);
	const brightness = (r * 0.299 + g * 0.587 + b * 0.114) / 255;

	// If brightness is less than or equal to 0.5, color is considered dark
	return brightness <= 0.5;
}

const isDark = computed(() => {
	return isDarkColor(props.sceneAssociatedColor);
})

const updateVisibleSceneIndex = () => {
	emit('scrollUpdate');
	emit('updateChosenScene', props.scene);
	emit('updateVisibleSceneIndex', props.index);
}

const style = computed(() => {
	let backgroundColor = hovering.value || buttonIsActive.value ? props.sceneAssociatedColor : 'white';
	let color = hovering.value && isDark.value ? 'white' : 'black';

	// If buttonIsActive is true, check isDark value for color
	if (buttonIsActive.value) {
		color = isDark.value ? 'white' : 'black';
	}

	return `background-color: ${backgroundColor}; color: ${color};`;
});

const mouseenter = () => {
	hovering.value = true;
};

const buttonIsActive = computed(() => {
	return props.index === props.activeIndex;
});

const mouseleave = () => {
	hovering.value = false;
}
</script>
